import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store/store";
import vuetify from "./plugins/vuetify";
import IdleVue from "idle-vue";
import upperFirst from "lodash/upperFirst";
import camelCase from "lodash/camelCase";

const requireComponent = require.context(
  // The relative path of the components folder
  "./components/BaseComp",
  // Whether or not to look in subfolders
  false,
  // The regular expression used to match base component filenames
  /Base[A-Z]\w+\.(vue|js)$/
);

requireComponent.keys().forEach(fileName => {
  // Get component config
  const componentConfig = requireComponent(fileName);

  // Get PascalCase name of component
  const componentName = upperFirst(
    camelCase(
      // Gets the file name regardless of folder depth
      fileName
        .split("/")
        .pop()
        .replace(/\.\w+$/, "")
    )
  );

  // Register component globally
  Vue.component(
    componentName,
    // Look for the component options on `.default`, which will
    // exist if the component was exported with `export default`,
    // otherwise fall back to module's root.
    componentConfig.default || componentConfig
  );
});

export const EventBus = new Vue({
  methods: {
    Printing(val) {
      this.$emit("PrintEvent", val);
    },
  },
});

const eventsHub = new Vue();

Vue.use(IdleVue, { store, eventEmitter: eventsHub, idleTime: 7 * 60 * 1000 });

Vue.config.productionTip = false;
Vue.mixin({
  methods: {
    Current(defount = new Date()) {
      let currentDate = new Date(defount);
      let month = currentDate.getMonth() + 1;
      let year = currentDate.getFullYear();
      let day = currentDate.getDate();
      let tom = currentDate.getDate() + 1;
      let hours = currentDate.getHours();
      let minits = currentDate.getMinutes();

      if (month < 10) month = "0" + month;
      if (day < 10) day = "0" + day;
      if (tom < 10) tom = "0" + tom;

      let date = year + "-" + month + "-" + day;
      let tomorrow = year + "-" + month + "-" + tom;
      let time = hours + ":" + minits + ":00";
      let Thismonth = year + "-" + month + "-01";
      return { date, time, Thismonth, tomorrow };
    },
  },
});
Vue.filter("MoneySigns", function(type) {
  if (!type) return null;
  let value = (type && type.value) || type;
  return store.getters.CashSigns.filter(element => {
    if (element.Cashcode == value) return element.CashSypol;
  })[0].CashSypol;
  // console.log(Signs);
  // return Signs.CashSypol;
});
new Vue({
  router,
  store,
  vuetify,
  render: h => h(App),
}).$mount("#app");
